module.exports = __webpack_public_path__ + "assets/img/4-3.a7f2bc92.jpg";